<template>
  <div style="width: 100%;position: relative;display: inline-block">
    <Breadcrumb :levelList="levelList" />
    <div class="input_box">
      <el-input style="width: 200px;margin-left: 20px"
                placeholder="词类名"
                v-model="wordClass"
                size="small"
                clearable>
      </el-input>
      <!-- <el-input style="width: 200px;margin-left: 20px"
                placeholder="同义词名"
                v-model="synonym"
                size="small"
                clearable>
      </el-input> -->
      <el-button style="float: right;margin-top: 20px;margin-right: 20px"
                 size="small"
                 icon="el-icon-search"
                 @click="currentPage(1)">搜索</el-button>
      <el-button type="success"
                 style="float: right;margin-top: 20px;margin-right: 20px"
                 size="small"
                 icon="el-icon-plus"
                 @click="openAddDialog()">新增词类</el-button>
    </div>
    <div class="table_box"
         v-loading="tableLoad">
      <el-table :data="tableData"
                size="mini"
                style="width: 100%">
        <el-table-column label="名称"
                         width="200"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.name}}
          </template>
        </el-table-column>
        <el-table-column label="同义词"
                         show-overflow-tooltip
                         min-width="300">
          <template slot-scope="scope">
            <div v-html="scope.row.synonymStr"></div>
            <!-- {{getTagListText(scope.row.synonyms)}} -->
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center">
          <template slot-scope="scope">
            <i class="el-icon-edit-outline"
               style="font-size: 16px;cursor: pointer"
               @click="editDialog(scope.row)"></i>
            <i class="el-icon-delete"
               style="font-size: 16px;cursor: pointer;margin-left: 10px;"
               @click="deleteDialog(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <Page v-bind:init_item="pageBuild"
            @currentPage="currentPage" />
    </div>
    <el-dialog custom-class="entityDialogClass"
               :title="dialog.isAdd ? '新增' : '修改'"
               :visible="dialog.open"
               width="480px"
               :show-close="false">
      <el-row class="pull-left aibfb aimb20"
              :span="24">
        <el-form ref="renamePopupForm"
                 label-width="60px">
          <el-form-item label="名称">
            <el-input v-model="dialog.name"
                      onkeypress="javascript:if(event.keyCode == 32 || event.keyCode == 13)event.returnValue = false;"
                      placeholder="请输入词类名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="addName"
                      onkeypress="javascript:if(event.keyCode == 32 || event.keyCode == 13)event.returnValue = false;"
                      size="small"
                      placeholder="回车增加同义词"
                      @keyup.enter.native="addTag()">
            </el-input>
            <div class="dialog_box">
              <div class="dialog_box_span"
                   v-for="(item, index) in dialog.synonyms"
                   :key="index">
                <span>{{item.name}}</span>
                <i class="el-icon-close dialog_box_span_close"
                   @click="deleteTag(item)"></i>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </el-row>
      <div style="text-align: center;margin-left: 20px">
        <el-button size="medium"
                   @click="dialog.open = false">取 消</el-button>
        <el-button type="primary"
                   size="medium"
                   :disabled="dialog.load"
                   v-if="dialog.isAdd"
                   @click="addObject()">确 定</el-button>
        <el-button type="primary"
                   size="medium"
                   :disabled="dialog.load"
                   v-if="!dialog.isAdd"
                   @click="editObject()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../components/crm/Breadcrumb'
import { getWordClassList, addWordClass, editWordClass, deleteWordClass } from '../../../api/entity/gather'
import Page from '../components/PageComponent'
export default {
  name: 'index',
  components: {
    Breadcrumb,
    Page
  },
  data () {
    return {
      levelList: [{ title: '集合实体' }],
      wordClass: '',
      synonym: '',
      wordLengthType: 1,
      tableData: [],
      tableLoad: false,
      pageBuild: {
        page_size: 10,
        total: 0,
        currentPage: 1
      },
      dialog: {
        isAdd: false,
        open: false,
        load: false,
        name: '',
        synonyms: []
      },
      addName: '',
      editItem: undefined
    }
  },
  methods: {
    getRandomId () {
      const randomNum = Math.random()
      let checkCode = randomNum * 9000
      checkCode += 1000
      const id = new Date().getTime() + '_entity_' + parseInt(checkCode)
      return id
    },
    getTagListText (list) {
      if (list && list.length > 0) {
        let str = ''
        list.forEach(function (item, index) {
          if (index !== 0) {
            str += ', '
          }
          str += item.name
        })
        return str
      } else {
        return ''
      }
    },
    currentPage (pageNumber) {
      this.pageBuild.currentPage = pageNumber
      this.search()
    },
    openAddDialog () {
      this.dialog.isAdd = true
      this.dialog.load = false
      this.dialog.open = true
      this.dialog.name = ''
      this.dialog.synonyms = []
      this.addName = ''
    },
    search () {
      const that = this
      const params = {
        wordLengthType: this.wordLengthType,
        categoryId: null,
        synonymLength: null,
        wordClass: this.wordClass,
        synonym: this.synonym,
        currentPage: this.pageBuild.currentPage,
        pageSize: this.pageBuild.page_size
      }
      this.tableLoad = true
      that.tableData = []
      getWordClassList(params).then(response => {
        if (response.data.code === 2000) {
          const data = response.data.data
          console.log(data)
          this.pageBuild.total = data.totalProperty
          if (data.root && data.root.length > 0) {
            data.root.forEach(function (item) {
              const json = { ...item }
              that.tableData.push(json)
            })
          }
          this.tableLoad = false
        } else {
          this.tableLoad = false
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    addTag () {
      if (this.addName === '') {
        window.entityMessage({ type: 'warning', text: '同义词不能为空' })
        return
      }
      const that = this
      const temp = this.dialog.synonyms.find(function (item) {
        return item.name === that.addName
      })
      if (!temp) {
        const json = {
          wordId: null,
          name: this.addName,
          wordclassId: null,
          length: 1
        }
        this.dialog.synonyms.push(json)
        this.addName = ''
      } else {
        window.entityMessage({ type: 'warning', text: '名称重复' })
      }
    },
    deleteTag (tag) {
      this.dialog.synonyms = this.dialog.synonyms.filter(function (item) {
        return tag.name !== item.name
      })
    },
    addObject () {
      if (this.dialog.name === '') {
        window.entityMessage({ type: 'warning', text: '请将数据填写完整' })
        return
      }
      const params = {
        id: null,
        name: this.dialog.name,
        categoryId: null,
        createdBy: null,
        createdTime: null,
        updatedBy: null,
        updatedTime: null,
        synonyms: this.dialog.synonyms,
        synonymStr: null,
        path: null
      }
      this.dialog.load = true
      addWordClass(params).then(response => {
        this.dialog.load = false
        if (response.data.code === 2000) {
          this.dialog.open = false
          this.currentPage(1)
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        this.dialog.load = false
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    editDialog (item) {
      const data = JSON.parse(JSON.stringify(item))
      this.dialog.isAdd = false
      this.dialog.load = false
      this.dialog.name = data.name
      this.dialog.synonyms = data.synonyms
      this.addName = ''
      this.editItem = data
      this.dialog.open = true
    },
    editObject () {
      if (this.dialog.name === '') {
        window.entityMessage({ type: 'warning', text: '请将数据填写完整' })
        return
      }
      const params = {
        id: this.editItem.id,
        name: this.dialog.name,
        categoryId: this.editItem.categoryId,
        createdBy: this.editItem.createdBy,
        createdTime: this.editItem.createdTime,
        updatedBy: this.editItem.updatedBy,
        updatedTime: this.editItem.updatedTime,
        synonyms: this.dialog.synonyms,
        synonymStr: this.editItem.synonymStr,
        path: this.editItem.path
      }
      this.dialog.load = true
      editWordClass(params).then(response => {
        this.dialog.load = false
        if (response.data.code === 2000) {
          this.dialog.open = false
          this.currentPage(1)
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        this.dialog.load = false
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    deleteDialog (item) {
      const that = this
      window.entityMessageBox({
        title: '提示',
        text: '此操作将永久删除, 是否继续?',
        f: function () {
          that.dialog.load = true
          deleteWordClass(item).then(response => {
            that.dialog.load = false
            if (response.data.code === 2000) {
              that.dialog.open = false
              that.currentPage(1)
            } else {
              window.entityMessage({ type: 'warning', text: response.data.msg })
            }
          }).catch(error => {
            that.dialog.load = false
            window.entityMessage({ type: 'error', text: error.data.msg })
          })
        },
        c: function () {
        }
      })
    }
  },
  mounted () {
    this.currentPage(1)
  }
}
</script>

<style scoped>
.input_box {
  width: auto;
  height: 80px;
  line-height: 80px;
}
.table_box {
  width: auto;
}
.dialog_box {
  width: 100%;
  height: 200px;
  border: #e1e3e6 solid 1px;
  overflow-y: auto;
  padding: 10px 10px;
  display: inline-block;
  line-height: 30px;
}
.dialog_box_span {
  margin: 5px;
  float: left;
  color: #337eff;
  border: #337eff solid 1px;
  border-radius: 4px;
  padding: 0 5px;
  position: relative;
}
.dialog_box_span_close {
  margin-left: 5px;
  cursor: pointer;
}
.dialog_box_span_close:hover {
  color: #f56c6c;
}
</style>
<style>
.el-table td {
  padding: 8px;
}
.el-table__expanded-cell {
  padding: 0 0 0 20px !important;
}
.entityDialogClass .el-dialog__body {
  display: inline-block;
}
.entityDialogClass .el-dialog__footer {
  text-align: center;
}
.entityDialogClass .el-dialog__body > .el-row {
  width: 400px;
}
.el-tooltip__popper {
  font-size: 14px;
  max-width: 70% !important;
}
</style>
